(function () {
  const storageKey = 'huawellRecentlyViewedProducts';
  const maxStoredProducts = 12;

  function readProducts() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeProducts(products) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(products.slice(0, maxStoredProducts)));
    } catch (error) {
      // localStorage can be unavailable in strict privacy contexts.
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character];
    });
  }

  function productCard(product) {
    const imageMarkup = product.image
      ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="360" height="360">`
      : '<span class="huawell-recently-viewed__placeholder">Product image pending</span>';

    return `
      <li class="huawell-recently-viewed__item">
        <article class="huawell-recently-viewed__card">
          <a class="huawell-recently-viewed__media" href="${escapeHtml(product.url)}">
            ${imageMarkup}
          </a>
          <div class="huawell-recently-viewed__body">
            <p class="huawell-recently-viewed__meta">${escapeHtml(product.meta)}</p>
            <h3><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h3>
            <div class="huawell-recently-viewed__actions">
              <a class="button button--secondary" href="${escapeHtml(product.url)}">Select &amp; Buy</a>
            </div>
          </div>
        </article>
      </li>
    `;
  }

  function parseCurrentProduct(section) {
    const script = section.querySelector('[data-huawell-current-product]');
    if (!script) return null;

    try {
      const product = JSON.parse(script.textContent || '{}');
      return product && product.handle ? product : null;
    } catch (error) {
      return null;
    }
  }

  function updateCurrentProduct(product) {
    if (!product) return;
    const products = readProducts().filter((item) => item.handle !== product.handle);
    products.unshift({ ...product, viewedAt: Date.now() });
    writeProducts(products);
  }

  function renderSection(section) {
    const currentProduct = parseCurrentProduct(section);
    const limit = Number(section.dataset.limit || 4);
    const list = section.querySelector('[data-huawell-recently-viewed-list]');
    const products = readProducts()
      .filter((item) => item.handle && (!currentProduct || item.handle !== currentProduct.handle))
      .slice(0, limit);

    updateCurrentProduct(currentProduct);

    if (!list || products.length === 0) {
      section.hidden = true;
      return;
    }

    list.innerHTML = products.map((product) => productCard(product)).join('');
    section.hidden = false;
  }

  function init() {
    document.querySelectorAll('[data-huawell-recently-viewed]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
